import axiosInstance from '@/api/apiClient'
import { getErrorMessage } from '@/lib/utils'

export const fetchStudentRooms = async (searchQuery?: string) => {
  try {
    const params: { search?: string } = {}
    if (searchQuery) params.search = searchQuery
    const response = await axiosInstance.get('/oge/rooms/self/', { params })
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const joinRoomApi = async (roomId: string, inviteCode: string) => {
  try {
    const response = await axiosInstance.post('/oge/rooms/join', {
      room_id: roomId,
      invite_code: inviteCode,
    })
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const joinRoomByCodeApi = async (inviteCode: string) => {
  try {
    const response = await axiosInstance.post('/oge/rooms/join-by-code', {
      invite_code: inviteCode,
    })
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const fetchNegotiationMessages = async (
  negotiationId: string | number,
  page: number = 1,
  pageSize: number = 20
) => {
  try {
    const response = await axiosInstance.get(
      `/oge/negotiations/${negotiationId}/messages/`,
      {
        params: {
          page,
          page_size: pageSize,
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}
